import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalStateService } from '../../services/modal-state.service';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'lib-modal-component',
  styleUrls: ['modal.component.scss'],
  templateUrl: 'modal.component.html',
  imports: [NgTemplateOutlet],
})
export class ModalComponent implements AfterViewInit, OnDestroy {
  private readonly modalRef = inject(NgbActiveModal);
  private readonly state = inject(ModalStateService);

  @ViewChild('modalContainer') public modalContainer: ElementRef<HTMLDivElement>;
  @ViewChild('modalContent') public modalContent: ElementRef<HTMLDivElement>;
  @ViewChild('submitButton') public submitButton: ElementRef<HTMLButtonElement>;
  @ViewChild('cancelButton') public cancelButton: ElementRef<HTMLButtonElement>;
  @ViewChild('closeButton') public closeButton: ElementRef<HTMLButtonElement>;
  @Input() public title: string;
  @Input() public content: any;
  @Input() public hideTopClose = false;
  @Input() public showButtons = false;
  @Input() public hideSubmit = false;
  @Input() public hideCancel = false;
  @Input() public okLabel = 'Save';
  @Input() public cancelLabel = 'Cancel';

  public get isHtmlContent() {
    return typeof this.content === 'string';
  }

  public get options() {
    return this.state.options;
  }

  public ngAfterViewInit() {
    if ('parentIFrame' in window) {
      (window['parentIFrame'] as any).getPageInfo((info) => {
        const modal = this.modalContainer.nativeElement;
        modal.style.top = `${Math.max(0, info.scrollTop - info.offsetTop) + 200}px`;
      });
    }

    const defaultFocusElRef = {
      content: this.modalContent,
      submit: this.submitButton,
      cancel: this.cancelButton,
      close: this.closeButton,
    }[this.options?.defaultFocus ?? 'content'];
    defaultFocusElRef?.nativeElement?.focus();
  }

  public ngOnDestroy() {
    if ('parentIFrame' in window) {
      (window['parentIFrame'] as any).getPageInfo(false);
    }
  }

  public yes() {
    this.modalRef.close('confirmed');
  }

  public no() {
    this.modalRef.dismiss('not confirmed');
  }
}
